<template>
  <div>
    <div class="user-list-container d-flex flex-row">
      <b-form-group id="input-group-1" label="کاربر  " label-for="input-1">
        <b-form-textarea
          v-if="multiSelect != '' && multiSelect != null"
          required
          v-model="name"
          placeholder="کاربر"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <b-form-input
          v-else
          id="input-1"
          required
          v-model="name"
          placeholder="کاربر  "
          disabled
        ></b-form-input>
      </b-form-group>
      <div class="my-auto">
        <b-button class="mr-3" variant="danger" v-b-modal="'user-modal'"
          >انتخاب کاربر</b-button
        >
      </div>
    </div>
    <b-modal
      id="user-modal"
      ok-title="انتخاب کاربر"
      cancel-title="انصراف"
      title="انتخاب کاربر"
      @ok="handleOk"
    >
      <div>
        <b-row>
          <div class="col-md-6">
            <b-form-group
              id="input-group-1"
              label="ایمیل: "
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                required
                v-model="params.email"
                placeholder="ایمیل "
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
              id="input-group-1"
              label="شماره همراه: "
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                required
                v-model="params.mobile"
                placeholder="شماره همراه "
              ></b-form-input>
            </b-form-group>
          </div>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="mr-3" variant="success" @click="searchUser"
              >جستجو</b-button
            >
            
          </b-col>
        </b-row>

        <b-table
        responsive
          style="width: 100%"
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fields"
          :items="datas"
        >
          <template v-slot:cell(details)="row">
            <b-form-checkbox
              v-if="multiSelect != '' && multiSelect != null"
              :id="'checkbox-' + row.item.id"
              :value="row.item.id"
              @change="selecMultitUser(row.item.id, row.item.name)"
            >
            </b-form-checkbox>

            <b-form-checkbox
              v-else
              :id="'checkbox-' + row.item.id"
              v-model="user_id"
              name="checkbox - 1"
              :value="row.item.id"
              @change="selectUser(row.item.id, row.item.name)"
            >
            </b-form-checkbox>
          </template>
        </b-table>
        <b-button-group v-if="page_count > 1">
          <b-button @click="searchUser(1)"
            ><i class="flaticon2-next"></i
          ></b-button>
          <b-button
            v-for="page in pages"
            v-bind:key="page"
            @click="searchUser(page)"
            :variant="page == current_page ? 'success' : 'default'"
            >{{ page }}</b-button
          >
          <b-button @click="searchUser(page_count)"
            ><i class="flaticon2-back"></i
          ></b-button>
        </b-button-group>
      </div>
    </b-modal>
  </div>
</template>
<style>
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 20px;
}
html .modal-dialog {
  max-width: 1000px;
}
html .user-list-container div {
  display: inline-block;
}
</style>

<script>
import httpHelper from "@/helpers/httpHelper";

export default {
  name: "UserList",
  props: ["multiSelect"],
  data: function () {
    return {
      fields: [
        {
          key: "id",
          label: "شماره",
        },
        {
          key: "name",
          label: "نام",
        },
        {
          key: "mobile",
          label: "موبایل",
        },
        {
          key: "email",
          label: "ایمیل",
        },
        {
          key: "details",
          label: "عملیات",
        },
      ],
      datas: [],
      pages: [],
      current_page: 0,
      page_count: 0,
      errors: [],
      users: [],
      name: "",
      names: [],
      user_id: 0,
      user_ids: [],
      params: [
        {
          label: "پست الکترونیکی",
          field: "email",
          type: "text",
        },
        {
          label: "تلفن همراه",
          field: "mobile",
          type: "text",
        },
      ],
    };
  },

  methods: {
    createPager(last_page, current_page) {
      this.pages = [];
      this.current_page = current_page;
      var startPageer = this.current_page > 5 ? this.current_page - 4 : 0;
      var endPageer = last_page > 5 ? this.current_page + 3 : last_page;
      this.page_count = last_page;
      if (this.current_page + 3 > this.page_count) {
        endPageer = this.page_count;
      }
      for (let i = startPageer; i < endPageer; i++) {
        this.pages.push(i + 1);
      }
    },

    searchUser: function (page = 1) {
      if (this.params.email != "" || this.params.mobile != "") {
        var params1 = "";
        if (this.params.email) {
          params1 += "&email=" + this.params.email;
        }
        if (this.params.mobile) {
          params1 += "&mobile=" + this.params.mobile;
        }
        httpHelper
          .getData("users/userlist" + "?page=" + page + params1)
          .then((res) => {
            if (res.success) {
              this.datas = res.result.data;
              this.createPager(res.result.last_page, res.result.current_page);
            } else {
            }
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
    selectUser: function (value, name) {
      if (value) {
        this.name = name;
      }
      this.$emit("input", value);
      this.$bvModal.hide("user-modal");
    },
    selecMultitUser: function (value, name) {
      if (value) {
        this.name += "[" + name + "]";
        this.user_ids.push(value);
      }
    },
    handleOk: function () {
      this.$emit("input", this.user_ids);
    },
  },
};
</script>